// New component created by srini on 02-04-25 for engagement  section

import { useState } from "react"
import { Grid, Typography, Tabs, Tab } from "@mui/material"
import { withStyles } from "@material-ui/core/styles"

import styles from './engagementStyles'

import ClientsList from "./ClientsList"
import AgentsList from "./AgentsList"
import Upload from "./Upload"

const Engagement = ({ classes }) => {
    const roleName = localStorage.getItem('roleName')

    const [tabId, setTabId] = useState(0)

    const handleTabChange = (value) => {
        setTabId(value)
    }

    return (
        <Grid container={tabId === 0} sx={{ margin: '110px 0 0 30px' }} >
            <Grid item xs={12} sx={{ marginBottom: '10px'}}>
                <Typography className={classes.engText}>Customer Engagement</Typography>
            </Grid>

            <Grid item xs={12} sx={{ marginTop: '10px'}}>
                <Tabs
                    value={tabId || 0} onChange={handleTabChange}
                    variant="standard" classes={{ indicator: classes.indicator }}
                >
                    <Tab
                        label={roleName === 'Agent' ? "View Clients" : "View Agents"}
                        value={0} onClick={() => handleTabChange(0)}
                        sx={{
                            borderBottom: tabId !== 0 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            fontFamily: tabId !== 0 ? 'cardiuma-regular' : 'cardiuma-SemiBold',
                        }}
                        className={classes.tabHead}
                    />
                    {roleName !== 'Agent' && <Tab
                        label="Upload"
                        value={1} onClick={() => handleTabChange(1)}
                        sx={{
                            borderBottom: tabId !== 1 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            fontFamily: tabId !== 1 ? 'cardiuma-regular' : 'cardiuma-SemiBold',
                            margin: "0 0 0 4%"
                        }}
                        className={classes.tabHead}
                    />}
                </Tabs>
            </Grid>


            {tabId === 0 && (roleName === 'Agent' ? <ClientsList /> : <AgentsList />)}

            <Grid item xs={12}>
                {tabId === 1 && <Upload />}
            </Grid>
        </Grid>
    );

}

export default withStyles(styles)(Engagement)